<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/E71vLy/tc-custom/9781459239883.jpg?1740885673066" alt="This image is the cover for the book Maiden's Abduction"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Maiden's Abduction
      </h1>
      <p class="bookDescription body article font2">
        <b>FEUDING FAMILIES</b><br/><br/>The Medwins and the La Vallons were longtime enemies. After Silas La Vallon’s sister was taken by the Medwins, the wealthy merchant had no choice but to retaliate and abduct Medwin’s daughter Isolde. Held captive in his house, then taken abroad to Belgium, the beautiful hellion softened to Silas’s sweet words and gentle kisses during the long days and longer nights. But Isolde could not forget he was a La Vallon and she was a Medwin. Theirs was a love that could never be.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Juliet Landon
      </h2>
      
      <p class="authorDescription body article">Juliet Landon is a professional embroiderer and lecturer, whose two disciplines go perfectly hand in hand. When she&rsquo;s not doing one, she&rsquo;s doing the other, often both on the same day. Her stories develop in her mind while stitches form on the fabric, and the one that wins depends on urgency and inclination. Juliet has been nominated for the Romantic Fiction Writer's Award, and she currently has at least another hundred ideas waiting to be released in the future.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?34977e8a